import React from 'react';
import {
    Container,
    makeStyles,
    Typography,
    Card,
    CardContent,
} from '@material-ui/core';
import Page from 'components/Page';
import {useTranslation} from "react-i18next";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import {Link} from 'react-router-dom';
import {Extension} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    list: {
        maxWidth: '500px'
    },
    icon: {
        minWidth: theme.spacing(4),
        color: 'rgba(0,0,0,0.8)'
    }
}));

const DocumentsView = () => {
    const classes = useStyles();
    const {t} = useTranslation();

    const sections = [
        {
            defaultIcon: PictureAsPdfIcon,
            items: [
                { name: "Všeobecné obchodné podmienky NEOSHIP účinné od 12.11.2025", file: "obchodne_podmienky_neoship_od_12_11_2025.pdf" },
                { name: "Cenník NEOSHIP účinný od 17.4.2023", file: "cennik_neoship_od_17_04_2023.pdf" },
                { name: "Fakturácia NEOSHIP", file: "fakturacia_neoship.pdf" },
            ],
        },
        {
            titleKey: 'title.documents_carriers',
            defaultIcon: PictureAsPdfIcon,
            items: [
                { name: "Všeobecné obchodné podmienky SPS", file: "obchodne_podmienky_SPS.pdf" },
                { name: "Všeobecné obchodné podmienky EXPRESS ONE", file: "obchodne_podmienky_INTIME.pdf" },
                { name: "Všeobecné obchodné podmienky GLS", file: "obchodne_podmienky_GLS.pdf" },
                { name: "Všeobecné obchodné podmienky PACKETA", file: "obchodne_podmienky_Packeta.pdf" },
            ],
        },
        {
            titleKey: 'title.documents_forms',
            defaultIcon: Extension,
            items: [
                { name: "Slovenká pošta - formulár žiadosti o reklamáciu zásielky", file: "ereklamacny-list_ecomplaint-form-zasielky-vnutrostatneho-styku-zmluvni-zakaznici.xls" },
            ],
        },
        {
            titleKey: 'title.documents_ebook',
            defaultIcon: PictureAsPdfIcon,
            items: [
                { name: "EBOOK - Krok za krokom k správnemu expedičnému riešeniu", file: "Krok_za_krokom_k_spravnemu_expedicnemu_rieseniu.pdf" },
            ],
        },
        {
            titleKey: 'title.modules',
            defaultIcon: Extension,
            items: [
                { name: "Neoship napojenie na PrestaShop 1.7+", file: "prestashop/neoship.zip" },
            ],
        },
    ];

    return (
        <Page title={t('navbar.documents')}>
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom>
                    {t('navbar.documents')}
                </Typography>
                {sections.map((section, sectionIndex) => (
                        <React.Fragment key={sectionIndex}>
                            {sectionIndex > 0 && <br />}
                            {section.titleKey && (
                                <Typography variant="h1" gutterBottom>
                                    {t(section.titleKey)}
                                </Typography>
                            )}
                            <Card>
                                <CardContent>
                                    <List
                                        component="nav"
                                        aria-labelledby="nested-list-subheader"
                                        className={classes.list}
                                        dense
                                    >
                                        {section.items.map((item, itemIndex) => {
                                            const ItemIcon = item.icon ?? section.defaultIcon;
                                            return (
                                                <ListItem
                                                    key={itemIndex}
                                                    button
                                                    component={Link}
                                                    to={"/documents/" + item.file}
                                                    target="_blank"
                                                >
                                                    <ListItemIcon className={classes.icon}>
                                                        <ItemIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={item.name} />
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </CardContent>
                            </Card>
                        </React.Fragment>
                ))}
            </Container>
        </Page>
    );
};

export default DocumentsView;
